import React from 'react';
import './Gateway.css';
import FMSimage from '../Assets/picture rmu.jpg'; // First image (full size)
import FMSimage2 from '../Assets/gateway1.jpg'; // Image for Key Features & Benefits
import FMSimage3 from '../Assets/gateway3.jpg'; // Image for How it Works section
import FMSimage4 from '../Assets/gateway5.jpg'; // Image for Why Choose section
import FMSimage5 from '../Assets/gateway4.jpg'; // Image for Industries section

const Gateway = () => {
    return (
        <div className="FMS-container">
            {/* First Section: Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <h1 className="FMS-heading">Remote Gateway Solutions</h1>
                    <p className="FMS-description">
                        Remote Gateway Solutions are designed to enable seamless and secure data transmission between remote devices and centralized systems. These solutions help in real-time monitoring, control, and communication for various industrial and commercial applications. Equipped with advanced connectivity options, they ensure reliable data exchange, enhancing efficiency and operational visibility.
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage} alt="Remote Gateway Solutions" className="FMS-image full-size" />
                </div>
            </div>

            {/* Centered Heading Between Images */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Key Features & Benefits</h2>
            </div>

            {/* Second Section: New Layout for Text and Image */}
            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Remote Gateway Solutions provide real-time data acquisition and transmission with secure connectivity. They support multiple communication protocols, ensuring seamless integration with existing infrastructure. Advanced security features protect against cyber threats, while cloud-based management enables remote access and control from anywhere.
                    </p>
                </div>

                {/* Right side: New Image for Key Features */}
                <div className="FMS-image-container">
                    <img src={FMSimage2} alt="Advanced Features" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* Centered Heading for How it Works */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">How it Works</h2>
            </div>

            {/* Third Section: Layout for How it Works */}
            <div className="FMS-content-container">
                {/* Left side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage3} alt="How It Works" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Remote Gateway Solutions function as intermediaries between remote devices and cloud or on-premise systems. They collect sensor data, process it locally if needed, and transmit it using secure communication channels. The system supports real-time monitoring, automated alerts, and data logging for better decision-making and proactive management.
                    </p>
                </div>
            </div>

            {/* New Section: Why Choose Us */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Why Choose Our Remote Gateway Solutions</h2>
            </div>

            <div className="FMS-content-container">
                {/* Left side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Remote Gateway Solutions offer seamless integration, robust security, and high reliability. They enable efficient remote monitoring and control, reducing operational costs and downtime. Key advantages include:
                        <ul>
                            <li>Secure and reliable data transmission</li>
                            <li>Compatibility with various industrial protocols</li>
                            <li>Real-time monitoring and analytics</li>
                            <li>Scalability for multiple applications</li>
                            <li>Cloud and on-premise deployment options</li>
                        </ul>
                    </p>
                </div>

                {/* Right side: Image */}
                <div className="FMS-image-container">
                    <img src={FMSimage4} alt="Why Choose Us" className="FMS-image smaller-size" />
                </div>
            </div>

            {/* New Section: Industries Using Our System */}
            <div className="FMS-bottom-heading">
                <h2 className="FMS-bottom-text">Industries Using Our Remote Gateway Solutions</h2>
            </div>

            <div className="FMS-content-container reverse-order-last">
                {/* Left side: Image for Industries */}
                <div className="FMS-image-container">
                    <img src={FMSimage5} alt="Industries Using Remote Gateway Solutions" className="FMS-image smaller-size" />
                </div>

                {/* Right side: Text Content */}
                <div className="FMS-text">
                    <p className="FMS-description">
                        Our Remote Gateway Solutions are widely used across industries for real-time data acquisition and secure communication. Industries benefiting from our solution include:
                        <ul>
                            <li>Smart Cities & IoT Infrastructure</li>
                            <li>Energy & Power Management</li>
                            <li>Industrial Automation</li>
                            <li>Oil & Gas Monitoring</li>
                            <li>Water Treatment & Utility Management</li>
                            <li>Telecommunications & Data Centers</li>
                        </ul>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Gateway;
